import * as Yup from 'yup'

const schema = Yup.object().shape({
  email: Yup.string()
    .required('E-mail é obrigatório')
    .email('Insira um e-mail válido'),
  phone: Yup.string().required('Telefone é obrigatório'),
  street: Yup.string().required('Rua/avenida obrigatório'),
  district: Yup.string().required('Bairro obrigatório'),
  number: Yup.number().required('Número da cada obrigatório'),
})

export default schema
